


































































































































































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutoCompleteAddress from '@/components/UI/autocomplete-address.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import InputMoney from '@/components/UI/input-money.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { EnderecoParmDTO } from '@/interfaces/address';
import { AnaliseParmDTO, CotacaoParmDTO, PropostaEfetivacaoParmDTO } from '@/interfaces/shipping-quote';
import * as service from '@/services/shipping-quote';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ShippingQuoteStatusChip from '../shipping-quote-status-chip.vue';
import ShippingQuoteAnaliseAddItemModal from './shipping-quote-analise-add-item-modal.vue';

@Component({
  components: {
    PermissionAuth,
    UiAutocompleClientsSubsidiaries,
    UiAutoCompleteAddress,
    ShippingQuoteStatusChip,
    InputMoney,
    ShippingQuoteAnaliseAddItemModal
  }
})
export default class ShippingQuoteAnaliseForm extends BaseComponent {
  @Prop()
  public chave: String;

  item = null;

  paciente = null;
  endereco = null;
  horario = null;

  formOpen = false;
  dto: any = {};
  items = [];

  showAddModalFlag = false;
  editItem = null;

  msgFooter = null;

  readonly = false;

  public form: any = {
    valid: false,
    rules: {
      opcao: [(v) => v != null || 'Selecione uma opção'],
      justificativa: [(v) => !!v || 'Informe uma justificativa'],
      logradouro: [(v) => !!v || 'Informe o logradouro'],
      numero: [(v) => !!v || 'Informe o número'],
      bairro: [(v) => !!v || 'Informe o bairro'],
      cidade: [(v) => !!v || 'Informe a cidade'],
      estado: [(v) => !!v || 'Informe o estado'],
      cep: [(v) => !!v || 'Informe o CEP']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  private headers: any = [
    { text: 'Horário limite de prescrição', sortable: false, width: '15%' },
    { text: 'Horário limite de entrega', sortable: false, width: '15%' },
    { text: 'Custo do frete', sortable: false, width: '15%' },
    { text: 'Observação', sortable: false },
    { text: '', sortable: false, width: '100' }
  ];

  private headersHist: any = [
    { text: 'Data', sortable: false, width: '15%' },
    { text: 'Usuário', sortable: false, width: '15%' },
    { text: 'Status', sortable: false, width: '15%' },
    { text: 'Observação', sortable: false }
  ];

  mounted() {
    this.readonly = !this.hasPermission([this.permissionsKeys.ANALISE_QUOTE_SHIPPING]);
  }

  @Watch('chave', { immediate: true })
  onKeyChange(chave) {
    if (!chave) {
      return;
    }

    this.load();
  }

  load() {
    this.loader.start('Carregando...');
    service.getShippingQuoteAnalise(this.chave).subscribe(
      (res) => {
        this.item = res;
        this.items = res.propostas
          ? res.propostas.map((p) => {
              return {
                ...p,
                custoFormat: 'R$ ' + this.decimalFormatHelper(p.custoEntrega),
                observacao: p.descricao
              };
            })
          : [];
        this.formOpen = true;
      },
      (error) => {
        this.showToastApiError(error);
        this.closeForm();
      },
      () => {
        this.loader.stop();
      }
    );
  }

  onRejeitadoChange(val) {
    if (this.dto.rejeitado === false) {
      this.openAddItemModal(null);
    }
  }

  openAddItemModal(editItem) {
    this.editItem = editItem;
    this.showAddModalFlag = true;
  }

  closeAddItemModal() {
    this.showAddModalFlag = false;
  }

  saveAddItemModal(item) {
    if (this.editItem) {
      this.deleteItem(this.editItem);
    }
    this.msgFooter = null;
    this.items.push(item);
    this.closeAddItemModal();
  }

  deleteItem(item) {
    this.items.splice(
      this.items.findIndex((i) => i === item),
      1
    );
  }

  closeForm() {
    this.$emit('close');
    this.formOpen = false;
  }

  save() {
    if (!this.$refs.form.validate()) {
      return;
    }
    let dto = this.dto;
    if (dto.rejeitado === false && !this.items.length) {
      this.msgFooter = 'Cadastre pelo menos uma cotação';
      return;
    }

    this.loader.start('Processando...');
    let payload = new AnaliseParmDTO();
    payload.chave = this.item.chave;
    payload.rejeitado = dto.rejeitado;
    payload.endereco = Object.assign(new EnderecoParmDTO(), this.item.endereco);

    if (this.dto.rejeitado === true) {
      payload.justificativa = dto.justificativa;
    } else {
      payload.cotacoes = this.items.map((c) => {
        let dto = new CotacaoParmDTO();
        dto.horarioLimitePrescricao = c.horarioLimitePrescricao;
        dto.horarioLimiteEntrega = c.horarioLimiteEntrega;
        dto.custoEntrega = c.custo;
        dto.descricao = c.observacao;
        return dto;
      });
    }

    service.saveShippingQuoteAnalise(payload).subscribe(
      (res) => {
        this.toast.show(res, 'success');
        this.$emit('save');
        this.formOpen = false;
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      },
      () => {
        this.loader.stop();
      }
    );
  }

  saveCancel() {
    this.dialog.show(
      'alert',
      'Salvar como Rejeitado',
      'Favor informar o motivo da rejeição',
      'Salvar',
      (confirma, motivo) => {
        this.saveAnaliseApprove(false, motivo);
      },
      'Fechar',
      () => {},
      null,
      null,
      null,
      null,
      null,
      true,
      'Motivo',
      'Motivo da rejeição'
    );
  }

  saveAnaliseApprove(approved, justification) {
    this.loader.start('Processando');

    let parm = new PropostaEfetivacaoParmDTO();
    parm.chave = this.item.chave;
    parm.efetivar = approved;
    parm.motivo = justification;

    service.saveShippingQuoteAnaliseApprove(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show(res, 'success');
        this.$emit('save');
        this.formOpen = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.loader.stop();
      }
    );
  }
}
